<template>
  <b-modal
    header-bg-variant="primary"
    modal-class="mc-modal-report__filter"
    :id="ids"
    :ref="ids"
    size="xl"
    centered
    scrollable
    static
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header>
      <h4 class="text-white">Model Laporan - {{ name }}</h4>
    </template>
    <b-card class="mc-report__filter">
      <b-tabs>
        <b-tab title="Data" active>
          <div class="mc-report__filter-wrapper">
            <b-row>
              <b-col md="4">
                <h5 class="mc-report__filter-title mb-3">Data Kolom</h5>
                <div
                  class="form-check d-flex justify-content-between mb-2"
                  v-if="!fields.find((field) => field.key === 'timeBetweenGeofence')"
                >
                  <b-form-checkbox
                    id="check-fleet"
                    v-model="isAllField"
                    :indeterminate="indeterminate"
                    @input="checkAllFields"
                    name="all"
                  >
                    Pilih Semua
                  </b-form-checkbox>
                </div>
                <div
                  class="form-check d-flex justify-content-between mb-2"
                  v-for="field in fieldsTemp"
                  :key="field.key"
                >
                  <b-form-checkbox
                    :id="'check-' + field.key"
                    v-model="selectedField[field.key]"
                    :disabled="field.disabled"
                    class="custom-disabled-checkbox checked"
                    :name="field.key"
                    checked
                  >
                    {{ field.label }}
                  </b-form-checkbox>
                  <b-button
                    @click="filterOpen = field.key"
                    size="sm"
                    variant="outline-primary"
                    v-if="field.filter"
                  >
                    <i class="icon-outline_filter"></i> Filter
                  </b-button>
                </div>
              </b-col>
              <b-col md="8">
                <h5 class="mc-report__filter-title mb-3">Filter</h5>
                <div class="mc-report__filter-notfound" v-if="!filterOpen">
                  <span>
                    <img src="@/assets/images/nofilter.png" alt />
                    <small>Tidak ada filter yang dipilih</small>
                  </span>
                </div>
                <div v-if="filterOpen == 'vehicle' || filterOpen=='licensePlate'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        v-if="!isFilterSingle.vehicle"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterVehicleSelected" class="mc-row-check">
                          <span class="badge btn-success">{{ filterVehicleSelected.length }}</span>
                          Baris terpilih.
                          <a class="color-primary" @click="clearDelete('vehicle')"
                            >Bersihkan semua</a
                          >
                        </h6>
                      </div>
                      <div
                        id="tickets-table_filter"
                        v-else-if="fields.find((field) => field.key === 'timeBetweenGeofence')"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterVehicleSelected" class="mc-row-check">
                          <span class="badge btn-success">{{
                            filterVehicleSelected.vehicleId ? '1' : '0'
                          }}</span>
                          Baris terpilih.
                          <a class="color-primary" @click="clearDelete('vehicle')">Bersihkan</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterVehicle"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        >
                        </b-form-input>
                      </label>
                    </b-col>
                  </b-row>

                  <div
                    class="table-responsive my-3 border border-1 mc-filter__table"
                    v-if="
                      fields.find((field) => field.key === 'timeBetweenGeofence') ||
                      name == 'Bahan Bakar' ||
                      name == 'Temperatur'
                    "
                  >
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="vehicleList"
                      :fields="fieldsVehicle"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterVehicle"
                      :filter-included-fields="['licensePlate', 'manufacturer', 'model', 'type']"
                    >
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="checkbox"
                            v-if="!isFilterSingle.vehicle"
                            :value="data.item.id"
                            v-model="filterVehicleSelected"
                            @input="checkVehicle"
                          />
                          <input
                            class="form-check-input me-1"
                            type="radio"
                            v-if="isFilterSingle.vehicle"
                            :value="{
                              vehicleId: data.item.id,
                              licensePlate: data.item.licensePlate,
                            }"
                            v-model="filterVehicleSelected"
                            @input="checkVehicle"
                          />
                        </div>
                      </template>
                      <template #cell(vehicleTypeName)="data">
                        {{ data.item.manufacturer || '-' }} / {{ data.item.model || '-' }} /
                        {{ data.item.type || '-' }}
                      </template>
                    </b-table>
                  </div>

                  <div v-else class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="vehicleList"
                      :fields="fieldsVehicle"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterVehicle"
                      :filter-included-fields="['licensePlate', 'manufacturer', 'model', 'type']"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            v-if="!isFilterSingle.vehicle"
                            v-model="selectAllVehicle"
                            @input="toggleAllVehicle"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="checkbox"
                            v-if="!isFilterSingle.vehicle"
                            :value="data.item.id"
                            v-model="filterVehicleSelected"
                            @input="checkVehicle"
                          />
                          <input
                            class="form-check-input me-1"
                            type="radio"
                            v-if="isFilterSingle.vehicle"
                            :value="data.item.id"
                            v-model="filterVehicleSelected"
                            @input="checkVehicleSensor(data.item)"
                          />
                        </div>
                      </template>
                      <template #cell(vehicleTypeName)="data">
                        {{ data.item.manufacturer || '-' }} / {{ data.item.model || '-' }} /
                        {{ data.item.type || '-' }}
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'driver'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterDriverSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{ filterDriverSelected.length }}</span>
                          Baris terpilih.
                          <a class="color-primary" @click="clearDelete('driver')"
                            >Bersihkan semua</a
                          >
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterDriver"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        >
                        </b-form-input>
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="employees.employees"
                      :fields="fieldsDriver"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterDriver"
                      :filter-included-fields="['fullname']"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            v-model="selectAllDriver"
                            @input="toggleAllDriver"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.userId"
                            v-model="filterDriverSelected"
                            @input="checkDriver"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'geofence'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterGeofenceSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{ filterGeofenceSelected.length }}</span>
                          Baris terpilih.
                          <a class="color-primary" @click="clearDelete('geofence')"
                            >Bersihkan semua</a
                          >
                        </h6>
                      </div>
                      <div
                        id="tickets-table_filter"
                        v-if="fields.find((field) => field.key === 'timeBetweenGeofence')"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterGeofenceSelected" class="mc-row-check">
                          <span class="badge btn-success">{{
                            filterGeofenceSelected.geofenceId ? '1' : '0'
                          }}</span>
                          Baris terpilih.
                          <a class="color-primary" @click="clearDelete('geofence')">Bersihkan</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterGeofence"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        >
                        </b-form-input>
                      </label>
                    </b-col>
                  </b-row>
                  <div
                    class="table-responsive my-3 border border-1 mc-filter__table"
                    v-if="fields.find((field) => field.key === 'timeBetweenGeofence' || field.key === 'visitedGeofence')"
                  >
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="geofences.geofences.data"
                      :fields="fields.find((field) => field.key === 'visitedGeofence') ? fieldsGeofence : fieldsGarage"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterGeofence"
                      :filter-included-fields="['fenceName']"
                    >
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="radio"
                            v-if="!isFilterSingle.geofence"
                            :value="{
                              geofenceId: data.item.geofenceId,
                              garage: data.item.fenceName,
                            }"
                            v-model="filterGeofenceSelected"
                            @input="checkGeofence"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                  <div class="table-responsive my-3 border border-1 mc-filter__table" v-else>
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="geofences.geofences.data"
                      :fields="fieldsGeofence"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterGeofence"
                      :filter-included-fields="['fenceName']"
                    >                      
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            v-model="selectAllGeofence"
                            @input="toggleAllGeofence"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.geofenceId"
                            v-model="filterGeofenceSelected"
                            @input="checkGeofence"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>

                <div v-if="filterOpen == 'alert'">
                  <b-row>
                    <b-col md="6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end float-start"
                      >
                        <h6 v-if="filterAlertSelected.length" class="mc-row-check">
                          <span class="badge btn-success">{{ filterAlertSelected.length }}</span>
                          Baris terpilih.
                          <a class="color-primary" @click="clearDelete('alert')">Bersihkan semua</a>
                        </h6>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <label class="float-end mc-table-view__search">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filterAlert"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                        >
                        </b-form-input>
                      </label>
                    </b-col>
                  </b-row>
                  <div class="table-responsive my-3 border border-1 mc-filter__table">
                    <b-table
                      small
                      show-empty
                      :empty-text="$t('global.emptyTable')"
                      :items="hiddenAlert"
                      :fields="fieldsAlert"
                      class="datatables"
                      responsive="sm"
                      empty-table
                      :filter="filterAlert"
                      :filter-included-fields="['descriptionIdn']"
                    >
                      <template #head(columnCheck)>
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="checkbox"
                            value="all"
                            v-model="selectAllAlert"
                            @input="toggleAllAlert"
                          />
                        </div>
                      </template>
                      <template #cell(columnCheck)="data">
                        <div class="form-check">
                          <input
                            class="form-check-input me-1"
                            type="checkbox"
                            :value="data.item.alertCode"
                            v-model="filterAlertSelected"
                            @input="checkAlert"
                          />
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="Susunan Kolom">
          <div class="mc-report__filter-wrapper">
            <b-row class="py-3">
              <b-col>
                <i id="tool-table-layout" class="icon-outline_info float-end"></i>

                <b-tooltip
                  target="tool-table-layout"
                  triggers="click"
                  placement="lefttop"
                  class="text-start"
                >
                  &#9900; Klik pada Nama kolom untuk mengganti Nama kolom<br />
                  &#9900; Tekan & tahan untuk mengubah susunan.
                </b-tooltip>
              </b-col>
            </b-row>

            <draggable v-model="fieldsTemp" class="mc-report__filter-draggable-wrapper mb-3">
              <transition-group>
                <span class="mc-report__filter-draggable" v-for="row in fieldsTemp" :key="row.key">
                  <i class="icon-fill_move me-2"></i> {{ row.label }}
                </span>
              </transition-group>
            </draggable>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>

    <template #modal-footer>
      <b-row class="mc-modal__filter-footer mc-modal__filter-footer--report">
        <b-col sm="12" md="8" class="mc-modal__filter-footer-fav">
          <b-row v-if="phaseOneShow">
            <b-col md="6">
              <b-form-group
                v-if="!isAddFavorit"
                id="favorit-label-modal"
                label="Favorit"
                label-for="favorit-modal"
              >
                <multiselect
                  v-model="fav"
                  :options="['Semua Model', 'Semua Kendaraan', 'Semua Wing']"
                  :show-labels="false"
                ></multiselect>
              </b-form-group>
              <b-form-group
                v-if="isAddFavorit"
                id="favorit-add-label-modal"
                label="Favorit"
                label-for="favorit-modal-add"
              >
                <b-form-input
                  id="favorit-modal-add"
                  v-model="addFavorit"
                  placeholder="Nama Favorit"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-button
                v-if="!isAddFavorit"
                variant="outline-primary"
                class="mt-4"
                @click="isAddFavorit = !isAddFavorit"
              >
                <i class="mdi mdi-file-plus-outline"></i> Buat Favorit Baru
              </b-button>
              <b-button v-if="isAddFavorit" variant="outline-primary" class="mt-4">
                <i class="bx bxs-save"></i> Simpan Sebagai Favorit
              </b-button>
              <i
                v-if="isAddFavorit"
                class="bx bx-trash-alt text-danger text-lg mt-4 mx-2"
                @click="isAddFavorit = !isAddFavorit"
              ></i>
            </b-col>
          </b-row>
        </b-col>

        <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
          <b-button variant="outline-primary" @click="cancelFilter()" class="me-3">
            Batal
          </b-button>
          <b-button variant="primary" @click="applyFilter()"> Terapkan </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { GET_EMPLOYEES } from '@/services/api/master/employees'
import { GET_VEHICLE } from '@/services/api/master/fleet'
import { GET_GEOFENCES } from '@/services/api/master/geofence'
import { NOTIFICATION_LIST_CODES } from '@/services/api/notification/general'
import draggable from 'vuedraggable'
import Swal from 'sweetalert2'

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isFilterSingle: {
      type: Object,
      default: () => ({
        vehicle: false,
        driver: false,
        geofence: false,
      }),
    },
  },
  components: {
    draggable,
  },
  apollo: {
    employees: {
      query: GET_EMPLOYEES,
      variables() {
        return {
          filter: {
            isDriver: true,
            isActive: true,
            orderBy: JSON.stringify({ fullname: 'asc' }),
          },
        }
      },
    },
    vehicles: {
      query: GET_VEHICLE,
      variables() {
        return {
          filter: {
            status: ['I', 'R', 'A'],
            orderBy: JSON.stringify({ licensePlate: 'asc' }),
          },
        }
      },
      result({ data, loading }) {
        if (loading) return

        var res = data.vehicles.vehicles

        var temp = []
        res.forEach(function (item, index) {
          temp[index] = {
            id: item.id,
            licensePlate: item.licensePlate,
            manufacturer: item.vehicleType ? item.vehicleType.manufacturer : null,
            model: item.vehicleType ? item.vehicleType.model : null,
            type: item.vehicleType ? item.vehicleType.type : null,
            door1: item.door1,
            door2: item.door2,
          }
        })

        this.vehicleList = temp
      },
    },
    geofences: {
      query: GET_GEOFENCES,
      variables() {
        return {
          filter: {
            orderBy: JSON.stringify({ fenceName: 'asc' }),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.geofences.geofences = data.geofences.geofences
        }
      },
    },
    alertCodes: {
      query: NOTIFICATION_LIST_CODES,
    },
  },
  data() {
    return {
      indeterminate: false,
      phaseOneShow: false,
      input: [],
      listData: this.data,
      isAllField: true,
      selectedField: {},
      filterOpen: null,
      fieldOrder: [],
      filterVehicleSelected: [],
      filterDriverSelected: [],
      filterGeofenceSelected: [],
      filterAlertSelected: [],
      selectAllVehicle: false,
      selectAllDriver: false,
      selectAllGeofence: false,
      selectAllAlert: false,
      filterVehicle: '',
      filterDriver: '',
      filterGeofence: '',
      filterAlert: '',
      employees: {
        employees: [],
      },
      vehicles: {
        vehicles: [],
      },
      geofences: {
        geofences: [],
      },
      alertCodes: {
        alertCodes: [],
      },
      vehicleList: [],
      fieldsDriver: [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fullname',
          label: 'Pengemudi',
          sortable: false,
        },
      ],

      fieldsVehicle: [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'licensePlate',
          label: 'Plat Nomor',
          sortable: false,
        },
        {
          key: 'vehicleTypeName',
          label: 'Jenis Kendaraan',
          sortable: false,
        },
      ],

      fieldsGeofence: [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fenceName',
          label: 'Geolokasi',
          sortable: false,
        },
      ],

      fieldsGarage: [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fenceName',
          label: 'Garasi',
          sortable: false,
        },
      ],

      fieldsAlert: [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'descriptionIdn',
          label: 'Jenis Peringatan',
          sortable: false,
        },
      ],

      fieldsTemp: [],
    }
  },
  computed: {
    ids() {
      var lowerCase = this.name.toLowerCase()

      return lowerCase.replaceAll(' ', '-')
    },
    hiddenAlert() {
      var alertCodes = this.alertCodes.alertCodes
      return alertCodes.filter(
        (x) =>
          x.alertCode != 42 &&
          x.alertCode != 43 &&
          x.alertCode != 44 &&
          x.alertCode != 45 &&
          x.alertCode != 46
      )
    },
  },
  mounted() {
    var selectedDefault = {}
    this.fields.forEach(function (item) {
      selectedDefault[item.key] = true
    })

    this.selectedField = selectedDefault

    this.fieldsTemp = this.fields

    this.$apollo.queries.vehicles.refetch({
      filter: {
        orderBy: JSON.stringify({ licensePlate: 'asc' }),
        status: ['I', 'R', 'A'],
        isHaveSensorTemperature: this.name == 'Temperatur' ? true : undefined,
        isHaveSensorFuel: this.name == 'Bahan Bakar' ? true : undefined,
        isHaveSensorDoor1: this.name == 'Pintu' ? true : undefined,
        isHaveSensorDoor2: this.name == 'Pintu' ? true : undefined,
      },
    })
  },
  watch: {
    immediate: true,
    selectedField: {
      handler(newval) {
        var count = 0
        var checkedTotal = Object.keys(this.selectedField).length
        Object.values(newval).forEach((val) => {
          if (val === true) {
            count = count + 1
          }
        })
        if (count === checkedTotal) {
          this.indeterminate = false
          this.isAllField = true
        } else if (count === 0) {
          this.indeterminate = true
          this.isAllField = false
        } else {
          this.indeterminate = true
        }
      },
      deep: true,
    },
  },
  methods: {
    applyFilter() {
      if (this.name == 'Peringatan') {
        if (this.filterVehicleSelected.length > 20) {
          return Swal.fire({
            title: 'Gagal',
            text: 'Kendaraan yang dipilih maksimal 20 kendaraan',
            imageUrl: require(`@/assets/images/alert-report-danger.png`),
            confirmButtonText: 'Tutup',
          })
        }
      }

      var allFilter = {
        fields: this.getSelectedFields(),
        filterDriver: this.filterDriverSelected,
        filterVehicle: this.filterVehicleSelected,
        filterGeofence: this.filterGeofenceSelected,
        filterAlert: this.filterAlertSelected,
      }
      this.$emit('input', allFilter)
      this.$bvModal.hide(this.ids)
    },

    cancelFilter() {
      this.$bvModal.hide(this.ids)
    },

    getSelectedFields() {
      var fieldsCheck = []
      var selected = this.selectedField
      Object.keys(this.selectedField).forEach(function (key) {
        if (key != 'all') {
          if (selected[key] === true) {
            fieldsCheck.push(key)
          }
        }
      })

      var fieldFilter = this.fieldsTemp.filter(function (item) {
        return fieldsCheck.includes(item.key)
      })
      return fieldFilter
    },

    checkAllFields(value) {
      var self = this
      this.fields.forEach(function (item) {
        if (!item.disabled) {
          self.selectedField[item.key] = value
        }
      })
    },

    checkVehicle(event) {
      if (event.target.checked) {
        this.filterVehicleSelected.push(parseInt(event.target.value))
        if (this.filterVehicleSelected.length == this.vehicles.vehicles.length) {
          this.selectAllVehicle = true
        }
      } else {
        this.selectAllVehicle = false
        var index = this.filterVehicleSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterVehicleSelected.splice(index, 1)
        }
      }
    },

    checkDriver(event) {
      if (event.target.checked) {
        this.filterDriverSelected.push(parseInt(event.target.value))
        if (this.filterDriverSelected.length == this.employees.employees.length) {
          this.selectAllDriver = true
        }
      } else {
        this.selectAllDriver = false
        var index = this.filterDriverSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterDriverSelected.splice(index, 1)
        }
      }
    },

    checkGeofence(event) {
      if (event.target.checked) {
        if(event.target.type != 'radio'){
          this.filterGeofenceSelected.push(parseInt(event.target.value))
          if (this.filterGeofenceSelected.length == this.geofences.geofences.data.length) {
            this.selectAllGeofence = true
          }
        }
      } else {
        this.selectAllGeofence = false
        var index = this.filterGeofenceSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterGeofenceSelected.splice(index, 1)
        }
      }
    },

    checkAlert(event) {
      if (event.target.checked) {
        this.filterAlertSelected.push(parseInt(event.target.value))
        if (this.filterAlertSelected.length == this.alertCodes.alertCodes.length) {
          this.selectAllAlert = true
        }
      } else {
        this.selectAllAlert = false
        var index = this.filterAlertSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterAlertSelected.splice(index, 1)
        }
      }
    },

    toggleAllVehicle(event) {
      var checked = event.target.checked
      this.filterVehicleSelected = []

      if (checked) {
        this.filterVehicleSelected = this.vehicles.vehicles.map((item) => item.id)
      } else {
        this.filterVehicleSelected = []
      }
    },

    toggleAllDriver(event) {
      var checked = event.target.checked
      this.filterDriverSelected = []

      if (checked) {
        this.filterDriverSelected = this.employees.employees.map((item) => item.userId)
      } else {
        this.filterDriverSelected = []
      }
    },

    toggleAllGeofence(event) {
      var checked = event.target.checked
      this.filterGeofenceSelected = []

      if (checked) {
        this.filterGeofenceSelected = this.geofences.geofences.data.map((item) => item.geofenceId)
      } else {
        this.filterGeofenceSelected = []
      }
    },

    toggleAllAlert(event) {
      var checked = event.target.checked
      this.filterAlertSelected = []

      if (checked) {
        this.filterAlertSelected = this.hiddenAlert.map((item) => item.alertCode)
      } else {
        this.filterAlertSelected = []
      }
    },

    clearDelete(field) {
      if (field == 'driver') {
        this.filterDriverSelected = []
        this.selectAllDriver = false
      } else if (field == 'vehicle') {
        this.filterVehicleSelected = []
        this.selectAllVehicle = false
      } else if (field == 'geofence') {
        this.filterGeofenceSelected = []
        this.selectAllGeofence = false
      } else if (field == 'alert') {
        this.filterAlertSelected = []
        this.selectAllAlert = false
      }
    },

    checkVehicleSensor(data) {
      if (this.name != 'Temperatur') return

      var indexDoor1 = this.fieldsTemp.findIndex((item) => {
        return item.key == 'door1'
      })

      if (indexDoor1 < 0) return

      this.fieldsTemp[indexDoor1].disabled = !data.door1
      this.selectedField.door1 = data.door1

      var indexDoor2 = this.fieldsTemp.findIndex((item) => {
        return item.key == 'door2'
      })

      if (indexDoor2 < 0) return

      this.fieldsTemp[indexDoor2].disabled = !data.door2
      this.selectedField.door2 = data.door2
    },

    checkVehicleInTW(event) {
      if (event.target.checked) {
        this.filterVehicleSelected.push(parseInt(event.target.value))
        if (this.filterVehicleSelected.length == this.vehicles.vehicles.length) {
          this.selectAllVehicle = true
        }
      } else {
        this.selectAllVehicle = false
        var index = this.filterVehicleSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterVehicleSelected.splice(index, 1)
        }
      }
    },
  },
}
</script>
